import gql from 'graphql-tag';

const cardAddressesDetails = gql`
  fragment cardAddressesDetails on AccountCard {
    id
    external_shipping_address {
      id
      name
      address_line_1
      address_line_2
      city
      state
      post_code
      country {
        id
        name
      }
    }
    external_shipping_addresses {
      total
      records {
        id
        name
        address_line_1
        address_line_2
        city
        state
        post_code
        country {
          id
          name
        }
      }
    }
    roster_identity_linked_identity_addresses(slice: { limit: 1 }) {
      total
      records {
        id
        name
        address_line_1
        address_line_2
        city
        state
        post_code
        country {
          id
          name
        }
        roster_identity_linked_identity {
          identity {
            id
            name
            last_name
            current_photo {
              id
              thumbnail_urls {
                size_code
                url
                width
                height
                quality
                mime_type
                mime
              }
            }
          }
        }
      }
    }
  }
`;

export default cardAddressesDetails;
